import { Component, OnInit, Output, Input, EventEmitter, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TasacionArchivo } from '../../models/TasacionArchivo';
import { TasacionesService } from '../../services/tasaciones.service';
import { DateHelper } from '../../models/NgDateCustomAdapter';
import { Router } from '@angular/router';
import { ArchivosService } from '../../services/archivos.service';



@Component({
  selector: 'app-file-browser',

  templateUrl: './file-browser.component.html',
  styleUrls: ['./file-browser.component.scss']
})
export class FileBrowserComponent implements OnInit {
  @Input() ArchivosList: any[];
  @Input() PanelTitle: string;
  @Output() FileDeleted: EventEmitter<any> = new EventEmitter();
  @Input() IsDeleted: boolean = true;
  @Input() isFromEntityType: boolean = false;
  @Input() entityId: any;

  constructor(private _TasacionesService: TasacionesService, public dateHelper: DateHelper, private router: Router, private _fileService: ArchivosService) { }

  ngOnInit() {
    console.log(this.ArchivosList)
  }


  isImage(archivo: TasacionArchivo): boolean {
    if (!archivo) {
      return;
    }

    if (!archivo.extension) {
      archivo.extension = archivo.fileName.substring(archivo.fileName.lastIndexOf('.'));
    }

    const ext = archivo.extension.toLowerCase();
    return (ext === '.jpg' || ext === 'png');
  }

  getIcon(archivo: TasacionArchivo): string {
    let iconclass = 'fas fa-file-alt';

    if (!archivo.extension) {
      archivo.extension = archivo.fileName.substring(archivo.fileName.lastIndexOf('.'));
    }
    const ext = archivo.extension.toLowerCase();
    if (ext === '.pdf') {
      iconclass = 'fas fa-file-pdf text-danger';
    } else if (ext === '.docx' || ext === '.doc') {
      iconclass = 'fas fa-file-word text-primary';
    }
    iconclass += ' fa-5x';
    return iconclass;
  }

  openFile(archivo: TasacionArchivo) {

    let url = '';
    if (this.isImage(archivo)) {
      if (this.isFromEntityType) {
        url = `api/File/Image/Entity/${archivo.id}/${this.entityId}`;
      } else {
        url = `api/File/Image/${archivo.id}`;
      }

    } else {
      if (this.isFromEntityType) {
        url = `api/File/Download/Entity/${archivo.id}/${this.entityId}`;
      } else {
        url = `api/File/Download/${archivo.id}`;
      }

    }
    window.open(url, '_blank');
  }

  FileDelete(id) {
    if (this.isFromEntityType) {
      this._fileService.deleteArchivo(this.entityId, id).subscribe(data => 
        this.FileDeleted.emit()
      )
    } else {
      this._TasacionesService.removeArchivoTasacion(id).subscribe(data => {
        this.FileDeleted.emit();
      });
    }
  }

  getThumbnailUrl(archivo: any): string {
    if (this.isFromEntityType) {
      return `api/File/Thumbnail/Entity/${archivo.id}/${this.entityId}`;
    }
    return `api/File/Thumbnail/${archivo.id}`;
  }
}
